unsetIndexes